/** Ключ «все категории» для фильтров услуг и товаров */
export const ALL_CATEGORY_KEY = 'all';

export type BookingPageCode = 0 | 1 | 2 | 3 | 5;
export type BookingStep = 1 | 2 | 3;
